var play_icon_default = {
  "shadow": "E1ZbA",
  "playIcon": "PGPP6"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
